<template>
  <div
    class="c-profileCard"
    :class="{ '-is-side': isSide }"
  >
    <CModal
      class="c-basicInfoInputAppeal"
      title="プロフィールの「業務領域」を登録しましょう"
      :active="isShowBasicInfoInputAppeal"
      @close="closeAppealModal"
    >
      <p>基本情報の「業務領域」をご登録いただくと、<br>出品者検索（職種・カテゴリ指定）で表示されるようになり販売促進につながります！</p>
      <CButton
        color="primary"
        size="medium"
        @click="appealModalButtonClicked"
      >登録する</CButton>
    </CModal>
    <div
      class="c-profileCard_notActiveArea"
      v-if="!isEditable && $util.isBeforePeriodDate(user.lastLoginedAt, 180)"
    >
      <div class="c-profileCard_notActive">
        <CoconalaIcon
          name="exclamation-circle"
          class="c-profileCard_notActiveIcon"
        />
        この出品者は半年以上ログインしていません。
      </div>
    </div>
    <div
      class="c-profileCard_notActiveArea"
      v-else-if="!isEditable && $util.isBeforePeriodDate(user.lastLoginedAt, 30)"
    >
      <div class="c-profileCard_notActive">
        <CoconalaIcon
          name="exclamation-circle"
          class="c-profileCard_notActiveIcon"
        />
        この出品者は30日以上ログインしていません。
      </div>
    </div>
    <div
      class="c-profileCard_banner"
      v-if="!isBusiness && !isNoBanner"
    >
      <Banner
        :is-editable="isEditable"
        :profile="user.profile"
      />
    </div>
    <div
      class="c-profileCard_main"
      :class="{ '-is-noBanner': isNoBanner || isBusiness }"
    >
      <div class="c-userInfo">
        <div class="c-basicInfo">
          <div class="c-basicInfo_icon">
            <UserIcon
              :file-path="user.resizableProfileIcon"
              :name="user.name"
              :is-editable="isEditable"
            />
          </div>
          <div class="c-basicInfo_name">
            <div class="c-userName">
              <span class="c-userName_text">
                {{ user.name }}
              </span>
              <span class="c-degreeIcon">
                <RankIcon
                  class="c-degreeIcon_level"
                  :width="rankIconWidth"
                  :level-value="user.level.value"
                  :level-name-text="user.level.nameText"
                  v-if="user.level && user.level.value"
                />
                <ProIcon
                  class="c-degreeIcon_certificationIcon"
                  :width="certificationIconWidth"
                  v-if="user.proFlag"
                />
                <DivinationIcon
                  class="c-degreeIcon_certificationIcon"
                  :width="certificationIconWidth"
                  v-else-if="user.certificationDivinationFlag"
                />
                <a
                  :href="$coconala.helpURL('/articles/4408643729689')"
                  target="_blank"
                  rel="noopener"
                  v-if="$coconala.isCoconalaManagementAccount(user.id)"
                >
                  <DLabel
                    @mouseenter.native="managementAccountLabelColor = 'Secondary900'"
                    @mouseleave.native="managementAccountLabelColor = 'Secondary'"
                    :background-color="managementAccountLabelColor"
                    class="c-degreeIcon_managementAccount"
                    text-color="White"
                  >
                    ココナラ運営
                  </DLabel>
                </a>
              </span>
              <DBusinessLabel
                class="c-businessLabel"
                is-tooltip
                tooltip-position="is-bottom-left"
                :has-divider="isPC"
                v-if="isBusiness"
              />
            </div>
          </div>
          <div class="c-basicInfo_status">
            <UserStatus
              :user-status="user.userStatus"
              :last-logined-at="user.lastLoginedAt"
              :is-editable="isEditable"
            />
          </div>
        </div>
        <div class="c-additionalInfo">
          <div
            class="c-occupation"
            v-if="user.profile && !isBusiness"
          >
            {{ user.profile.occupation }}
          </div>
          <div
            class="c-userProfile"
            v-if="!isBusiness"
          >
            <span class="c-userProfile_text -userType">{{ corporateFgText }}</span>
            <span
              class="c-userProfile_text -age"
              v-if="user.profile && user.profile.isDisplayAge && user.age"
            >{{ user.age }}</span>
            <span
              class="c-userProfile_text -sex"
              v-if="user.sex"
            >{{ sexText }}</span>
            <span
              class="c-userProfile_text -location"
              v-if="prefectureText"
            >{{ prefectureText }}</span>
          </div>
          <UserData
            :is-business="isBusiness"
            :is-blog="isBlog"
            :is-side="isSide"
            :achievementCount="user.achievementCount"
            :ratingAvg="user.ratingAvg"
            :followerCount="user.followerCount"
            :is-identification="user.identificationFg"
            :is-nda-conclusion="user.ndaConclusionFg"
            :is-editable="isEditable"
            :schedule="user.schedule"
            v-if="!isPcSide"
          />
        </div>
        <div
          class="c-userAction"
          v-if="!isEditable && !isOwner"
        >
          <div
            class="c-userAction_menu"
            :class="{ 'c-userAction_menu-withoutFollowButton': !isShowFollowButton }"
            v-if="isLoggedIn"
          >
            <ActionMenu
              dropdown
              :is-editable="isEditable"
            />
          </div>
          <transition name="follow-button">
            <div
              class="c-userAction_follow"
              v-if="isShowFollowButton"
            >
              <CButton
                :is-active="!user.userRelation.followingFlag"
                :disabled="isDisabledFollowButton"
                :icon-name="!user.userRelation.followingFlag ? 'user-plus' : 'user-check'"
                :size="$store.state.ui.viewport.device === 'sp' ? 'small' : ''"
                @click="toggleFollow"
              >
                {{ !user.userRelation.followingFlag ? 'フォローする' : 'フォロー中' }}
              </CButton>
            </div>
          </transition>
        </div>
      </div>
      <div
        class="c-conversionButton"
        v-if="isEditable"
      >
        <EditorBasicInfo
          :is-visible="isShowBasicInfoEditor"
          :user="user"
          @close="isShowBasicInfoEditor = false"
        />
        <CButton
          color="primary"
          class="c-conversionButton_basicInfo"
          @click="isShowBasicInfoEditor = true"
        >
          <CoconalaIcon name="pencil-square-o" />&nbsp;基本情報を編集する
        </CButton>
        <CButton
          color="secondary"
          is-outlined
          @click="switchEditMode"
        >
          自分のページを見る
        </CButton>
      </div>
      <div
        class="c-conversionButton -is-owner"
        v-else-if="isOwner"
      >
        <p
          class="c-customizeStatus"
          v-if="!isBusiness && !isPcSide"
        >
          見積り・仕事の相談：{{ customizeStatusText }}
          <CoconalaIcon
            name="circle"
            :class="{ '-is-stop': isStopCustomize }"
          />
        </p>
        <CButton
          v-if="!isBusiness"
          color="secondary"
          is-outlined
          @click="switchEditMode"
        >
          自分のページを編集する
        </CButton>
      </div>
      <div
        class="c-conversionButton"
        v-else
      >
        <CustomizeButton
          v-if="!isBusiness"
          :user-id="user.id"
          :origin="CUSTOMIZE_ORIGINS.PROFILE"
        />
        <CButton
          :href="$coconala.directMessageURL(user.id)"
          :target="isSP ? '_self' : '_blank'"
          @click="onClickDM"
        >
          メッセージを送る
        </CButton>
      </div>
      <UserData
        :is-business="isBusiness"
        :is-blog="isBlog"
        :is-side="isSide"
        :achievementCount="user.achievementCount"
        :ratingAvg="user.ratingAvg"
        :followerCount="user.followerCount"
        :is-identification="user.identificationFg"
        :is-nda-conclusion="user.ndaConclusionFg"
        :is-editable="isEditable"
        :schedule="user.schedule"
        v-if="!isBusiness && isPcSide"
      />
    </div>
    <div
      class="c-customizeStatusEdit"
      v-if="isEditable && !isPcSide"
    >
      <div class="c-customizeStatusEditPanel">
        <div v-if="isStopCustomize">
          「受付を再開する」を押すと、プロフィールページに「見積り・仕事の相談をする」ボタンが表示されます。<br>
          ※出品サービスの受付休止は個別に設定が必要です。設定は<a
            :href="$coconala.url('/mypage/services_lists')"
            target="_blank"
          >こちら</a>
        </div>
        <div v-else>
          「受付を休止する」を押すと、プロフィールページの「見積り・仕事の相談をする」ボタンが非表示になります。<br>
          ※出品サービスの受付休止は個別に設定が必要です。設定は<a
            :href="$coconala.url('/mypage/services_lists')"
            target="_blank"
          >こちら</a>
        </div>
        <div class="c-customizeStatusEditPanel_button">
          <p class="c-customizeStatus">
            見積り・仕事の相談：{{ customizeStatusText }}
            <CoconalaIcon
              name="circle"
              :class="{ '-is-stop': isStopCustomize }"
            />
          </p>
          <CButton
            color="primary"
            isFull
            @click="toggleCustomize"
          >{{ isStopCustomize ? '受付を再開する' : '受付を休止する' }}</CButton>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditorBasicInfo from '~/components/organisms/EditorBasicInfo'
import CustomizeButton from '~/components/molecules/buttons/CustomizeButton'
import RankIcon from '~/components/molecules/RankIcon'
import ProIcon from '~/components/molecules/ProIcon'
import DBusinessLabel from '~/components/molecules/DS2/DBusinessLabel'
import DLabel from '~/components/atoms/DS2/DLabel'
import DivinationIcon from '~/components/molecules/Divination'

// local components
import Banner from './components/Banner'
import UserIcon from './components/UserIcon'
import UserStatus from './components/UserStatus'
import ActionMenu from './components/ActionMenu'
import UserData from './components/UserData'

// mixins
import formMixin from '~/mixins/form-mixin'

// vuex
import { mapState, mapGetters, mapActions } from 'vuex'

const COOKIE_KEY = 'has_basic_info_appeal_modal_shown'
const COOKIE_VALUE = 'true'

export default {
  name: 'TheProfileCard',
  mixins: [formMixin],
  components: {
    EditorBasicInfo,
    CustomizeButton,
    RankIcon,
    ProIcon,
    Banner,
    UserIcon,
    UserStatus,
    ActionMenu,
    UserData,
    DBusinessLabel,
    DLabel,
    DivinationIcon
  },
  props: {
    user: {
      type: Object
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    userIcon: {
      type: String
    },
    isSide: {
      type: Boolean,
      default: false
    },
    isBlog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowBasicInfoEditor: false,
      isShowBasicInfoInputAppeal: false,
      isShowFollowButton: false,
      isDisabledFollowButton: false,
      managementAccountLabelColor: 'Secondary'
    }
  },
  computed: {
    ...mapGetters('auth', ['isFromCoconalaApp', 'isLoggedIn']),
    ...mapGetters('ui', ['isPC', 'isSP']),
    ...mapGetters('pages/users/user', ['isProviderAttribute', 'isBusiness']),
    ...mapState('constants', ['CUSTOMIZE_ORIGINS']),
    ...mapState('ui', ['viewport']),
    ...mapState('pages/users/user', ['isBusiness']),
    isOwner() {
      return this.$store.getters['pages/users/isOwner']
    },
    prefectureText() {
      if (this.isEditable) {
        return this.$store.getters['pages/users/my/user/prefectureText']
      }
      return this.$store.getters['pages/users/user/prefectureText']
    },
    sexText() {
      if (this.isEditable) {
        return this.$store.getters['pages/users/my/user/sexText']
      }
      return this.$store.getters['pages/users/user/sexText']
    },
    corporateFgText() {
      if (this.isEditable) {
        return this.$store.getters['pages/users/my/user/corporateFgText']
      }
      return this.$store.getters['pages/users/user/corporateFgText']
    },
    isNoBanner() {
      return !this.isEditable && (this.user.profile && !this.user.profile.coverImageUrl)
    },
    isBlockee() {
      return this.user.userRelation && this.user.userRelation.blockeeFlag
    },
    isStopCustomize() {
      return this.user.userStatus && this.user.userStatus.isStopCustomize
    },
    isPcSide() {
      return this.isSide && this.isPC
    },
    customizeStatusText() {
      return this.isStopCustomize ? '休止中' : '受付中'
    },
    rankIconWidth() {
      switch (this.viewport.size) {
        case 'FULL':
          return '32px'
        case 'XL':
          return '32px'
        case 'L':
          return '30px'
        case 'M':
          return '30px'
        case 'S':
          return '22px'
        default:
          return '22px'
      }
    },
    certificationIconWidth() {
      switch (this.viewport.size) {
        case 'FULL':
          return '35px'
        case 'XL':
          return '35px'
        case 'L':
          return '30px'
        case 'M':
          return '30px'
        case 'S':
          return '22px'
        default:
          return '22px'
      }
    }
  },
  watch: {
    'user.userRelation.followingFlag': function(followingFlag) {
      // 原則フォロー不可である購入者属性ユーザまたはビジネスユーザの場合、かつ、フォロー解除の操作をされた後は、フォローボタンを非表示にする
      // フォロー解除完了が認識できるようにsetTimeoutを使う
      if ((!this.isProviderAttribute || this.user.isBusiness) && !followingFlag) {
        setTimeout(() => {
          this.isShowFollowButton = false
        }, 1000)
      }
    }
  },
  created() {
    if (this.isEditable) {
      const hasBasicInfoAppealModalShown = this.$cookies.get(COOKIE_KEY)
      if (hasBasicInfoAppealModalShown) return
      if (this.user.userJobsList.length > 0) return
      this.isShowBasicInfoInputAppeal = true
    }
  },
  mounted() {
    this.setIsShowFollowButton()
  },
  methods: {
    ...mapActions('ui', ['showLoginModal']),
    ...mapActions('pages/users/user', ['addFollow', 'deleteFollow']),
    ...mapActions('pages/users/my/user', ['stopCustomize']),
    onClickDM(e) {
      if (!this.isLoggedIn) {
        e.preventDefault()
        this.showLoginModal()
      }
      if (this.isBlockee) {
        e.preventDefault()
        this.$notify({
          group: 'flash',
          type: 'warn',
          title: 'このユーザーにはメッセージを送信できません'
        })
      }
    },
    switchEditMode() {
      // 出品者HPかブログかで分ける
      let path = ''
      if (this.$route.path.match(/^\/blogs\//)) {
        path = this.isEditable
          ? this.$route.path.replace(RegExp('^/mypage/blogs'), `/blogs/${this.user.id}`)
          : this.$route.path.replace(RegExp('^/blogs/[0-9]+'), '/mypage/blogs')
      } else {
        path = this.isEditable
          ? this.$route.path.replace(RegExp('^/mypage/user'), `/users/${this.user.id}`)
          : this.$route.path.replace(RegExp('^/users/[0-9]+'), '/mypage/user')
      }

      if (this.isFromCoconalaApp) {
        location.href = path
      } else {
        this.$router.push({ path }, () => {})
      }
    },
    setIsShowFollowButton() {
      // 購入者属性またはビジネスユーザの場合原則フォローボタン非表示だが、すでにフォローされている場合のみボタンを表示して解除できるようにする
      if (this.isBlockee) {
        this.isShowFollowButton = false
        return
      }

      const followingFlag = this.user.userRelation?.followingFlag ?? false
      if (followingFlag && this.user.isBusiness) {
        this.isShowFollowButton = true
        return
      }
      if (this.user.isBusiness) {
        this.isShowFollowButton = false
        return
      }
      if (followingFlag || this.isProviderAttribute) {
        this.isShowFollowButton = true
        return
      }
      this.isShowFollowButton = false
    },
    async toggleFollow() {
      if (!this.isLoggedIn) return this.showLoginModal()
      if (this.user.userRelation.followingFlag) {
        // 購入者属性またはビジネスのユーザの場合フォロー解除後にボタンが消えるため、disabled制御をして、消えるまでの間に再フォローもさせない
        if (!this.isProviderAttribute || this.user.isBusiness) {
          this.isDisabledFollowButton = true
        }
        await this.deleteFollow()
        this.doNotifySuccess('フォローを解除しました')
      } else {
        await this.addFollow()
        this.doNotifySuccess('フォローしました')
      }
    },
    async toggleCustomize() {
      await this.stopCustomize({ isStopCustomize: !this.isStopCustomize })
      const message = this.isStopCustomize ? '受付を休止しました' : '受付を再開しました'
      this.doNotifySuccess(message)
    },
    appealModalButtonClicked() {
      this.isShowBasicInfoInputAppeal = false
      this._setAppealModalCookie()
      this.isShowBasicInfoEditor = true
    },
    closeAppealModal() {
      this.isShowBasicInfoInputAppeal = false
      this._setAppealModalCookie()
    },
    _setAppealModalCookie() {
      this.$cookies.set(COOKIE_KEY, COOKIE_VALUE, {
        path: '/',
        maxAge: 60 * 60 * 24 * 7
      })
    }
  }
}
</script>
<style lang="scss" scoped src="./style.scss">
</style>
